var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"98%","background":"#fff","width":"98%","margin":"10px auto"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"img"},[_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"duobi"}},[_c('img',{attrs:{"src":require("../assets/img/robot/duobi.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"duobiBig"}},[_c('img',{attrs:{"src":require("../assets/img/robot/duobiBig.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dOne"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dOne.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dTwo"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dTwo.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dThree"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dThree.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dFour"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dFour.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dFive"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dFive.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dSix"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dSix.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dSeven"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dSeven.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dEight"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dEight.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"dNight"}},[_c('img',{attrs:{"src":require("../assets/img/robot/dNight.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.eighteen != 1),expression:"eighteen != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"bottom"}},[_c('img',{attrs:{"src":require("../assets/img/door/bottom.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.eighteen != 1),expression:"eighteen != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"screan"}},[_c('img',{attrs:{"src":require("../assets/img/door/screan.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.eighteen != 1),expression:"eighteen != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"tou"}},[_c('img',{attrs:{"src":require("../assets/img/door/tou.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.eighteen != 1),expression:"eighteen != 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"ai"}},[_c('img',{attrs:{"src":require("../assets/img/door/ai.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.eighteen == 1),expression:"eighteen == 1"},{name:"drag",rawName:"v-drag",value:({
				go: _vm.go,
				setPan: _vm.setPan,
				getPan: _vm.getPan,
				setOne: _vm.setOne,
				getOne: _vm.getOne,
				setTwo: _vm.setTwo,
				getTwo: _vm.getTwo,
				setThree: _vm.setThree,
				getThree: _vm.getThree,
				setFour: _vm.setFour,
				getFour: _vm.getFour,
				setFive: _vm.setFive,
				getFive: _vm.getFive,
				setSix: _vm.setSix,
				getSix: _vm.getSix,
				setSeven: _vm.setSeven,
				getSeven: _vm.getSeven,
				setEight: _vm.setEight,
				getEight: _vm.getEight,
				setNight: _vm.setNight,
				getNight: _vm.getNight,
				setTen: _vm.setTen,
				getTen: _vm.getTen,
				setEleven: _vm.setEleven,
				getEleven: _vm.getEleven,
				setTwelve: _vm.setTwelve,
				getTwelve: _vm.getTwelve,
				setThirteen: _vm.setThirteen,
				getThirteen: _vm.getThirteen,
				setFourteen: _vm.setFourteen,
				getFourteen: _vm.getFourteen,
				setFifteen: _vm.setFifteen,
				getFifteen: _vm.getFifteen,
				setSixteen: _vm.setSixteen,
				getSixteen: _vm.getSixteen,
				setSeventeen: _vm.setSeventeen,
				getSeventeen: _vm.getSeventeen,
				setEighteen: _vm.setEighteen,
				getEighteen: _vm.getEighteen,
				setNighteen: _vm.setNighteen,
				getNighteen: _vm.getNighteen,
			}),expression:"{\n\t\t\t\tgo,\n\t\t\t\tsetPan,\n\t\t\t\tgetPan,\n\t\t\t\tsetOne,\n\t\t\t\tgetOne,\n\t\t\t\tsetTwo,\n\t\t\t\tgetTwo,\n\t\t\t\tsetThree,\n\t\t\t\tgetThree,\n\t\t\t\tsetFour,\n\t\t\t\tgetFour,\n\t\t\t\tsetFive,\n\t\t\t\tgetFive,\n\t\t\t\tsetSix,\n\t\t\t\tgetSix,\n\t\t\t\tsetSeven,\n\t\t\t\tgetSeven,\n\t\t\t\tsetEight,\n\t\t\t\tgetEight,\n\t\t\t\tsetNight,\n\t\t\t\tgetNight,\n\t\t\t\tsetTen,\n\t\t\t\tgetTen,\n\t\t\t\tsetEleven,\n\t\t\t\tgetEleven,\n\t\t\t\tsetTwelve,\n\t\t\t\tgetTwelve,\n\t\t\t\tsetThirteen,\n\t\t\t\tgetThirteen,\n\t\t\t\tsetFourteen,\n\t\t\t\tgetFourteen,\n\t\t\t\tsetFifteen,\n\t\t\t\tgetFifteen,\n\t\t\t\tsetSixteen,\n\t\t\t\tgetSixteen,\n\t\t\t\tsetSeventeen,\n\t\t\t\tgetSeventeen,\n\t\t\t\tsetEighteen,\n\t\t\t\tgetEighteen,\n\t\t\t\tsetNighteen,\n\t\t\t\tgetNighteen,\n\t\t\t}"}],attrs:{"id":"all"}},[_c('img',{attrs:{"src":require("../assets/img/robot/allScrean.png"),"alt":""}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"button"},[_vm._v("进入CocoBlockly编程平台")]),_vm._v(" "),_c('video',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"musicC","src":require('../assets/music/click.mp3')}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip"},[_c('img',{attrs:{"src":require("../assets/img/robot/tips.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('img',{attrs:{"src":require("../assets/img/right.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"downLine"},[_c('img',{attrs:{"src":require("../assets/img/robot/downLine.png"),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upLine"},[_c('img',{attrs:{"src":require("../assets/img/robot/upLine.png"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fdce0ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/robot.vue
// module id = null
// module chunks = 